import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    jwplayer: any; //eslint-disable-line
  }
}

interface VideoPlayerProps {
  videoPlayListID: string | undefined;
}

export default function VideoPlayer({
  videoPlayListID,
}: Readonly<VideoPlayerProps>) {
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (videoPlayListID === undefined) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jwplayer.com/libraries/398EyOMo.js';
    script.async = true;
    script.onload = () => {
      if (playerRef.current) {
        window.jwplayer(playerRef.current.id).setup({
          playlist: `https://cdn.jwplayer.com/v2/playlists/${videoPlayListID}?format=json`,
        });
      }
    };
    playerRef.current?.appendChild(script);
  }, [videoPlayListID]);

  return <Box id='videoPlayer' data-testid='video-player' ref={playerRef} />;
}
